import React from 'react';
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from 'lucide-react';
import "../styles/legalDocs.css";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ChevronLeft className="w-8 h-8" />
        </button>
        <h1
          className="top-title"
          style={{ fontFamily: "unset", fontSize: "21px" }}
        >
          Terms & Conditions
        </h1>
      </div>

      <div className="legal-docs">
        {/* 1. Terms & Conditions */}
        {/* <h1>Terms & Conditions</h1> */}
        <p><strong>Effective Date:</strong> 24/03/2025</p>

        <p>These Terms & Conditions ("Terms") govern your access to and use of <strong>trippin</strong> (the "App"), a social media platform operated by <strong>Socius Apps Ltd</strong> ("Company," "we," "us," or "our"). By using the App, you agree to be bound by these Terms. If you do not agree, you must discontinue use of the App immediately.</p>

        <h2>1. ELIGIBILITY</h2>
        <p><strong>1.1</strong> You must be at least 13 years old to use the App. If you are under the age of 18, you must have parental or legal guardian consent.</p>
        <p><strong>1.2</strong> By using the App, you confirm that you have the legal capacity to enter into these Terms and comply with applicable laws.</p>

        <h2>2. USER ACCOUNTS & RESPONSIBILITIES</h2>
        <p><strong>2.1</strong> To access certain features, you may need to create an account by providing accurate and complete information.</p>
        <p><strong>2.2</strong> You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</p>
        <p><strong>2.3</strong> You agree not to:</p>
        <ul>
          <li>Share your account credentials with others.</li>
          <li>Impersonate another person or entity.</li>
          <li>Create multiple accounts for abusive or deceptive purposes.</li>
        </ul>

        <h2>3. ACCEPTABLE USE & CONTENT GUIDELINES</h2>
        <p><strong>3.1</strong> You may not post, upload, or share content that:</p>
        <ul>
          <li>Contains hate speech, threats, or promotes violence.</li>
          <li>Depicts or promotes drugs, weapons, or illegal activities.</li>
          <li>Includes nudity, pornography, or sexually explicit material.</li>
          <li>Misleads, deceives, or impersonates another person.</li>
          <li>Infringes on intellectual property rights, including copyrighted material without permission.</li>
          <li>Contains spam, phishing attempts, or malicious software.</li>
        </ul>
        <p><strong>3.2</strong> We reserve the right to remove content, restrict features, and suspend or terminate accounts that violate these guidelines, with or without notice.</p>
        <p><strong>3.3</strong> Users are encouraged to report violations using the report feature within the App.</p>
        <p><strong>3.4</strong> We may cooperate with law enforcement authorities if required to investigate illegal activities or threats related to content posted in the App.</p>

        <h2>4. DATA COLLECTION & PRIVACY</h2>
        <p><strong>4.1</strong> We collect, store, and process personal data in compliance with GDPR, CCPA, COPPA, and other applicable data protection laws to ensure user privacy and security.</p>
        <p><strong>4.2</strong> The data we collect may include:</p>
        <ol>
          <li><strong>Personal Information:</strong> Name, email, profile details.</li>
          <li><strong>Device Permissions:</strong> Camera, gallery, microphone, and location access.</li>
          <li><strong>Usage Data:</strong> App activity and interactions to improve user experience.</li>
          <li><strong>Advertising Data:</strong> Information related to Facebook Ads & Google Ads.</li>
          <li><strong>Log Data:</strong> IP address, device information, and access timestamps for security and analytics.</li>
        </ol>
        <p><strong>4.3</strong> We use Google Cloud Services for secure data hosting, encryption, and protection against unauthorized access.</p>
        <p><strong>4.4</strong> Users have the right to access, update, or delete their personal data through their account settings or by contacting our support team.</p>
        <p><strong>4.5</strong> We do not knowingly collect or process data from users under the age of 13 in compliance with COPPA and other child protection laws.</p>
        <p><strong>4.6</strong> For more details on how we collect, use, and share data, please refer to our Privacy Policy.</p>

        <h2>5. USER-GENERATED CONTENT & INTELLECTUAL PROPERTY</h2>
        <p><strong>5.1</strong> By posting content on the App, you grant us a non-exclusive, worldwide, royalty-free license to use, store, and distribute it solely for the purpose of operating and improving the App.</p>
        <p><strong>5.2</strong> You retain ownership of your content but acknowledge that we have the right to remove or restrict access to any content that violates these Terms.</p>
        <p><strong>5.3</strong> You may not:</p>
        <ul>
          <li>Copy, distribute, or modify content from the App without authorization.</li>
          <li>Use automated means to scrape or collect data from the App.</li>
          <li>Impersonate another person, entity, or misrepresent your identity.</li>
          <li>Interfere with or disrupt the App's security, servers, or networks.</li>
        </ul>

        <h2>6. ACCOUNT TERMINATION & DELETION</h2>
        <p><strong>6.1</strong> You may delete your account at any time through the settings menu. Upon deletion, all associated data will be permanently removed from our systems, except where retention is required by law or for legitimate business purposes (e.g., fraud prevention, dispute resolution).</p>
        <p><strong>6.2</strong> We reserve the right to suspend, restrict, or terminate accounts that violate these Terms, applicable laws, or community guidelines, including but not limited to:</p>
        <ul>
          <li>Posting prohibited content (e.g., hate speech, violence, illegal activities).</li>
          <li>Misuse of the App, including fraudulent activities or attempts to manipulate our platform.</li>
          <li>Repeated violations of our policies, even after warnings.</li>
        </ul>
        <p><strong>6.3</strong> If your account is suspended or terminated, you may not create a new account without our express permission.</p>
        <p><strong>6.4</strong> If you believe your account was wrongfully suspended or terminated, you may appeal the decision through our support system. However, we retain full discretion over final account status decisions.</p>

        <h2>7. ADVERTISING & THIRD-PARTY SERVICES</h2>
        <p><strong>7.1</strong> The App uses third-party advertising services, including Facebook Ads and Google Ads, which may collect data to deliver personalized ads. By using the App, you agree to their terms and privacy policies.</p>
        <p><strong>7.2</strong> We are not responsible for the content, policies, or practices of third-party advertisers or external websites linked from the App. Clicking on ads may redirect you to external sites, and any interactions with them are at your own risk.</p>
        <p><strong>7.3</strong> If you encounter misleading or inappropriate ads, you may report them through our support system or via the advertising platform's reporting options.</p>
        <p><strong>7.4</strong> We reserve the right to modify or remove advertisements within the App at our discretion.</p>

        <h2>8. REPORT SYSTEM & ENFORCEMENT</h2>
        <p><strong>8.1</strong> Users can report content that violates these Terms using the built-in report feature within the App. Reports should be made in good faith and should not be used to harass or target other users unfairly.</p>
        <p><strong>8.2</strong> Upon receiving a report, we will review the reported content and take appropriate action based on our internal policies and applicable laws. Actions may include, but are not limited to:</p>
        <ul>
          <li>Content removal (e.g., deleting posts, comments, or media).</li>
          <li>Issuing warnings to the user responsible for the violation.</li>
          <li>Temporary or permanent account suspension in cases of repeated or severe violations.</li>
          <li>Reporting illegal activities to law enforcement authorities, if necessary.</li>
        </ul>
        <p><strong>8.3</strong> We reserve the right to act at our sole discretion and are not obligated to disclose details of our review process or the actions taken.</p>
        <p><strong>8.4</strong> Users found to be abusing the report system, such as making false reports or engaging in malicious reporting, may face penalties, including account suspension.</p>
        <p><strong>8.5</strong> If you believe that your content was wrongfully removed or your account was unfairly suspended, you may submit an appeal request through our support system. However, we retain final decision-making authority regarding all enforcement actions.</p>

        <h2>9. LIMITATION OF LIABILITY</h2>
        <p><strong>9.1</strong> The App is provided "as is" and "as available", without warranties of any kind, either express or implied. We do not guarantee that the App will be error-free, secure, uninterrupted, or that it will meet your expectations or specific requirements.</p>
        <p><strong>9.2</strong> We do not warrant that any content available on or through the App is accurate, complete, reliable, or up-to-date. You acknowledge that your use of the App is at your own risk.</p>
        <p><strong>9.3</strong> To the maximum extent permitted by law, we shall not be liable for:</p>
        <ul>
          <li>Loss, corruption, or unauthorized access to user data, personal information, or account details.</li>
          <li>Content posted by users that may be harmful, offensive, or violate laws or third-party rights.</li>
          <li>Any direct, indirect, incidental, consequential, punitive, or special damages, including but not limited to financial loss, loss of business opportunities, reputational harm, or personal injury arising from the use or inability to use the App.</li>
        </ul>
        <p><strong>9.4</strong> In jurisdictions where limitations of liability are restricted, our liability shall be limited to the minimum extent permitted by law.</p>

        <h2>10. GOVERNING LAW & DISPUTE RESOLUTION</h2>
        <p><strong>10.1</strong> These Terms are governed by and construed in accordance with the laws of Cyprus, without regard to its conflict of laws principles.</p>
        <p><strong>10.2</strong> In the event of a dispute, you agree to first attempt to resolve the issue amicably through negotiation. Both parties shall make a good-faith effort to reach a resolution within 30 days of the dispute arising.</p>
        <p><strong>10.3</strong> If the dispute remains unresolved, it shall be referred to binding arbitration in Cyprus, conducted in accordance with the rules of a recognized arbitration institution. The arbitration shall be held in English, and the decision of the arbitrator(s) shall be final and binding on both parties.</p>
        <p><strong>10.4</strong> You agree that any claims shall be brought on an individual basis and not as part of any class action or collective proceeding.</p>
        <p><strong>10.5</strong> Nothing in this section shall prevent either party from seeking injunctive or equitable relief in a court of competent jurisdiction where necessary to prevent actual or threatened infringement, misappropriation, or violation of intellectual property rights.</p>

        <h2>11. CHANGES TO THESE TERMS</h2>
        <p><strong>11.1</strong> We may update, modify, or revise these Terms from time to time to reflect changes in legal requirements, business operations, or user feedback.</p>
        <p><strong>11.2</strong> When we make significant changes, we will notify users via in-app notifications, email (if provided), or by posting an updated version of the Terms within the App.</p>
        <p><strong>11.3</strong> It is your responsibility to review the updated Terms periodically. Continued use of the App after changes take effect constitutes your acceptance of the revised Terms.</p>

        <h2>12. CONTACT INFORMATION</h2>
        <p>For any questions or concerns about these Terms, please contact us at:</p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:support@socius.icu">support@socius.icu</a></li>
          <li><strong>Address:</strong> Megalou Alexandrou, 38, 2682, Paliometoxo, Nicosia, Cyprus</li>
        </ul>
        <p>By using <strong>trippin</strong>, you agree to abide by these Terms & Conditions.</p>
        
        <br />
        {/* 2. EULA */}
        <h1>End User License Agreement</h1>
        <p><strong>Effective Date:</strong> 24/03/2025</p>
        <p><strong>Last Updated:</strong> 24/03/2025</p>
        <p><strong>Company Name:</strong> Socius Apps Ltd</p>
        <p><strong>Registered Office:</strong> Megalou Alexandrou, 38, 2682, Paliometoxo, Nicosia, Cyprus</p>

        <p>This <strong>End User License Agreement (EULA) and User-Generated Content (UGC) Policy</strong> ("Agreement") governs the use of the [App Name] mobile application ("App") and its related services. By downloading, installing, or using the App, you agree to be bound by the terms of this Agreement. If you do not agree, you must discontinue the use of the App immediately.</p>

        <h2>1. DEFINITIONS</h2>
        <p><strong>1.1 "App"</strong> refers to the trippin mobile application and its related services.</p>
        <p><strong>1.2 "Company"</strong> refers to Socius Apps Ltd, a business entity registered in Cyprus.</p>
        <p><strong>1.3 "User" or "You"</strong> refers to any individual accessing or using the App.</p>
        <p><strong>1.4 "User-Generated Content (UGC)"</strong> refers to any content (including but not limited to text, images, videos, audio, or other materials) submitted, uploaded, or shared by users within the App.</p>

        <h2>2. LICENSE GRANT & RESTRICTIONS</h2>
        <p><strong>2.1 License Grant:</strong> Subject to compliance with this Agreement, we grant you a limited, non-exclusive, non-transferable, and revocable license to use the App for personal, non-commercial purposes.</p>
        <p><strong>2.2 Restrictions:</strong> You shall not:</p>
        <ul>
          <li>Copy, modify, distribute, lease, sublicense, or sell any part of the App.</li>
          <li>Reverse-engineer, decompile, or attempt to extract the App's source code.</li>
          <li>Use the App for any unlawful or prohibited activities.</li>
          <li>Interfere with or disrupt the App's security or performance.</li>
        </ul>

        <h2>3. AGE REQUIREMENTS</h2>
        <p><strong>3.1 Minimum Age:</strong> You must be at least 13 years old to use the App.</p>
        <p><strong>3.2 Parental Consent:</strong> If you are between 13 and 18 years old, you must have parental or guardian permission.</p>
        <p><strong>3.3 COPPA Compliance:</strong> We do not knowingly collect data from children under 13. If we discover a user is under 13, we will terminate the account and delete associated data.</p>

        <h2>4. USER-GENERATED CONTENT (UGC) POLICY</h2>
        <p><strong>4.1 Ownership:</strong> You retain ownership of the content you create and share within the App.</p>
        <p><strong>4.2 License to Use UGC:</strong> By posting content, you grant the Company a worldwide, royalty-free, non-exclusive, transferable, and sublicensable license to use, modify, distribute, and display your content within the App for operational and promotional purposes.</p>
        <p><strong>4.3 Prohibited Content:</strong> You agree not to post content that:</p>
        <ul>
          <li>Promotes hate speech, violence, discrimination, abuse, harassment, or self-harm.</li>
          <li>Contains nudity, pornography, sexually explicit material, or illegal drug-related content.</li>
          <li>Violates copyrights, trademarks, or other intellectual property rights.</li>
          <li>Contains false, misleading, or deceptive information.</li>
          <li>Encourages criminal activity or terrorism.</li>
        </ul>
        <p><strong>4.4 Moderation & Enforcement:</strong></p>
        <p>The Company reserves the right to remove, restrict, or suspend any content that violates this Agreement. Repeat offenders may face account suspension or termination.</p>
        <p><strong>4.5 Reporting System:</strong></p>
        <p>Users can report violations through our in-app reporting system. We will review reports and take appropriate action.</p>

        <h2>5. DATA COLLECTION & PROCESSING</h2>
        <p><strong>5.1 Personal Data Collected</strong></p>
        <p>We collect and process the following data in compliance with GDPR (EU), CCPA (California), COPPA (USA), and other data protection laws:</p>
        <ol>
          <li><strong>Location Data:</strong> Used for app functionality (e.g., location tagging in posts).</li>
          <li><strong>Camera & Gallery Access:</strong> Required for uploading photos and videos.</li>
          <li><strong>Microphone Access:</strong> Used for voice features and video content.</li>
          <li><strong>Behavioral Data:</strong> Analyzed to enhance user experience.</li>
        </ol>
        <p><strong>5.2 Data Protection & Storage</strong></p>
        <ul>
          <li>Data is securely stored on Google Cloud Services.</li>
          <li>You have the right to request data deletion via the in-app account deletion feature.</li>
        </ul>
        <p><strong>5.3 Third-Party Services</strong></p>
        <ul>
          <li>We use Facebook Ads and Google Ads, which may collect additional data.</li>
          <li>Advertisements may be personalized based on your app activity.</li>
        </ul>
        <p>For more details, refer to our Privacy Policy.</p>

        <h2>6. ACCOUNT SUSPENSION & TERMINATION</h2>
        <p><strong>6.1 Suspension & Termination</strong></p>
        <p>We may suspend or terminate your account if you:</p>
        <ul>
          <li>Repeatedly violate our User-Generated Content Policy.</li>
          <li>Engage in fraudulent or illegal activities.</li>
          <li>Attempt to manipulate or interfere with the App's functionality.</li>
        </ul>
        <p><strong>6.2 Appeals</strong></p>
        <p>If your account is suspended or terminated, you may contact <a href="mailto:support@socius.icu">support@socius.icu</a> to appeal the decision. All appeals will be reviewed on a case-by-case basis, and the Company reserves the right to make the final determination.</p>

        <h2>7. INTELLECTUAL PROPERTY RIGHTS</h2>
        <p><strong>7.1 Ownership of App Content</strong></p>
        <p>All content, trademarks, logos, and software within the App are owned by Socius Apps Ltd and are protected by intellectual property laws. Unauthorized use, reproduction, or distribution of any part of the App without prior written consent is strictly prohibited.</p>
        <p><strong>7.2 User Content Rights</strong></p>
        <p>By submitting content, you grant us permission to display, distribute, and modify it for app operations. You confirm that you have the necessary rights to share the content and that it does not infringe on any third-party intellectual property rights.</p>

        <h2>8. DISCLAIMERS & LIMITATIONS OF LIABILITY</h2>
        <p><strong>8.1 No Warranties</strong></p>
        <p>The App is provided on an "as is" and "as available" basis without warranties of any kind. We do not guarantee that the App will be uninterrupted, error-free, or free from harmful components.</p>
        <p><strong>8.2 Limitation of Liability</strong></p>
        <p>We are not responsible for:</p>
        <ul>
          <li>Any loss, damage, or harm arising from your use of the App.</li>
          <li>The actions or content posted by other users.</li>
          <li>Any unauthorized access to or use of our servers and personal data stored therein.</li>
          <li>Any third-party services, advertisements, or links accessed through the App.</li>
        </ul>

        <h2>9. CHANGES TO THIS AGREEMENT</h2>
        <p>We reserve the right to update or modify this Agreement at any time. Continued use of the App after changes indicates acceptance of the updated terms. We will notify users of significant changes through in-app notifications or other appropriate means.</p>

        <h2>10. GOVERNING LAW & DISPUTE RESOLUTION</h2>
        <p><strong>10.1 Governing Law</strong></p>
        <p>This Agreement shall be governed by and construed in accordance with the laws of Cyprus.</p>
        <p><strong>10.2 Dispute Resolution</strong></p>
        <p>Any disputes arising under this Agreement shall be resolved through arbitration in the Cyprus, unless otherwise required by law.</p>

        <h2>11. CONTACT INFORMATION</h2>
        <p>For any questions or concerns regarding this Agreement, please contact us at:</p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:support@socius.icu">support@socius.icu</a></li>
          <li><strong>Company Address:</strong> Megalou Alexandrou, 38, 2682, Paliometoxo, Nicosia, Cyprus.</li>
        </ul>

        <br />
        {/* 3. Data Processing Agreement */}
        <h1>Data Processing Agreement</h1>

        <h2>1. INTRODUCTION</h2>
        <p>This Data Processing Agreement ("DPA") is made between <strong>Socius Apps Ltd</strong>, a company registered in Cyprus (hereinafter referred to as the "Company"), and users of the <strong>trippin</strong> mobile application (hereinafter referred to as the "App").</p>
        <p>This agreement ensures compliance with applicable data protection laws, including:</p>
        <ul>
        <li><strong>General Data Protection Regulation (GDPR) (EU)</strong></li>
        <li><strong>California Consumer Privacy Act (CCPA) (USA)</strong></li>
        <li><strong>Children's Online Privacy Protection Act (COPPA) (USA)</strong></li>
        <li><strong>Other relevant international and national data protection regulations</strong></li>
        </ul>
        <p>By using the App, the user agrees to the terms outlined in this DPA.</p>

        <h2>2. DEFINITIONS</h2>
        <ul>
        <li><strong>"Personal Data"</strong> refers to any information relating to an identified or identifiable individual.</li>
        <li><strong>"Processing"</strong> means any operation performed on Personal Data, including collection, storage, analysis, and deletion.</li>
        <li><strong>"Data Controller"</strong> refers to Socius Apps Ltd, which determines the purposes and means of processing Personal Data.</li>
        <li><strong>"Data Processor"</strong> refers to any third party that processes data on behalf of the Company.</li>
        </ul>

        <h2>3. CATEGORIES OF DATA COLLECTED</h2>
        <p>The Company collects and processes the following categories of Personal Data:</p>
        <ol>
        <li><strong>Profile Information:</strong> Name, email address, profile picture</li>
        <li><strong>User-Generated Content:</strong> Photos, videos, and location metadata</li>
        <li><strong>Device Data:</strong> Access to camera, microphone, gallery</li>
        <li><strong>Behavioral Data:</strong> User interactions within the App for service improvement</li>
        <li><strong>Advertising Data:</strong> Information shared with Google Ads and Facebook Ads for targeted advertising</li>
        </ol>

        <h2>4. PURPOSE OF DATA PROCESSING</h2>
        <p>The Company processes user data for the following purposes:</p>
        <ol>
        <li><strong>App Functionality:</strong> Allowing users to create and share content</li>
        <li><strong>User Experience Optimization:</strong> Improving app features based on behavioral analytics</li>
        <li><strong>Security & Compliance:</strong> Preventing fraud, enforcing community guidelines</li>
        <li><strong>Advertising:</strong> Delivering personalized ads using Google Ads and Facebook Ads</li>
        </ol>

        <h2>5. LEGAL BASIS FOR DATA PROCESSING</h2>
        <p>The Company processes Personal Data under the following legal bases:</p>
        <ol>
        <li><strong>User Consent:</strong> For accessing camera, microphone, gallery, and location data</li>
        <li><strong>Legitimate Interest:</strong> For security, analytics, and service optimization</li>
        <li><strong>Contractual Necessity:</strong> To provide core app functionality</li>
        <li><strong>Legal Compliance:</strong> To meet regulatory requirements</li>
        </ol>

        <h2>6. DATA STORAGE AND SECURITY</h2>
        <ul>
        <li>All data is securely stored on Google Cloud Services.</li>
        <li>The Company employs encryption, access controls, and security audits to protect user data.</li>
        <li><strong>Account Deletion:</strong> Users may delete their account at any time, and all associated data will be permanently removed within 30 days.</li>
        </ul>

        <h2>7. USER RIGHTS</h2>
        <p>Under GDPR, CCPA, and other applicable laws, users have the following rights:</p>
        <ol>
        <li><strong>Right to Access:</strong> Request a copy of their Personal Data.</li>
        <li><strong>Right to Rectification:</strong> Correct inaccurate or incomplete data.</li>
        <li><strong>Right to Erasure ("Right to be forgotten"):</strong> Delete their data upon request.</li>
        <li><strong>Right to Restrict Processing:</strong> Limit how their data is processed.</li>
        <li><strong>Right to Data Portability:</strong> Obtain their data in a structured, machine-readable format.</li>
        <li><strong>Right to Object:</strong> Opt out of data processing, including targeted advertising.</li>
        </ol>
        <p>Requests regarding data rights can be made via <a href="mailto:support@socius.icu">support@socius.icu</a>.</p>

        <h2>8. DATA SHARING AND THIRD-PARTY PROCESSORS</h2>
        <ul>
        <li>The Company does not sell Personal Data.</li>
        <li>The Company shares limited data with:
            <ul>
            <li>Google Ads and Facebook Ads for advertising.</li>
            <li>Google Cloud Services for data storage.</li>
            <li>Law enforcement authorities when required by legal obligation.</li>
            </ul>
        </li>
        </ul>

        <h2>9. DATA RETENTION</h2>
        <ul>
        <li>Personal Data is retained as long as the user maintains an active account.</li>
        <li>Deleted accounts and associated data are permanently removed within 30 days.</li>
        <li>Certain data may be retained for a longer period if required by legal obligations or to resolve disputes.</li>
        </ul>

        <h2>10. CHILDREN'S DATA PROTECTION</h2>
        <ul>
        <li>The App is strictly for users aged 13 and above.</li>
        <li>The Company does not knowingly collect data from users under 13.</li>
        <li>If we become aware that a user under 13 has provided Personal Data, we will take immediate steps to delete the information.</li>
        </ul>

        <h2>11. VIOLATIONS AND ACCOUNT SUSPENSION</h2>
        <p>Users violating the Community Guidelines may have their content removed, account suspended, or permanently deleted. Repeated violations or severe misconduct may result in a permanent ban without prior notice.</p>

        <h2>12. CONTACT INFORMATION</h2>
        <p>For any questions regarding data protection, users may contact:</p>
        <ul>
        <li><strong>Email:</strong> <a href="mailto:support@socius.icu">support@socius.icu</a></li>
        <li><strong>Company Address:</strong> Megalou Alexandrou, 38, 2682, Paliometoxo, Nicosia, Cyprus.</li>
        </ul>

        <br />
        {/* 4. Community Guidelines */}
        <h1>Community Guidelines</h1>

        <h2>1. PURPOSE</h2>
        <p>The Community Guidelines ensure a safe, respectful, and engaging environment for all users. By using the App, users agree to follow these guidelines. Failure to comply may result in content removal, account suspension, or permanent banning.</p>

        <h2>2. RESPECT AND SAFETY</h2>
        <p>Users must:</p>
        <ul>
          <li>Treat others with respect</li>
          <li>Engage in constructive discussions</li>
          <li>Report harmful behavior</li>
        </ul>
        <p>Users must not:</p>
        <ul>
          <li>Harass, bully, or threaten others</li>
          <li>Promote self-harm, suicide, or violence</li>
          <li>Share misleading or harmful information</li>
        </ul>

        <h2>3. PROHIBITED CONTENT</h2>
        <p>Users must not post, share, or promote:</p>
        <ol>
          <li>
            <strong>Hate Speech:</strong> Content targeting individuals based on race, gender, religion, or identity.
          </li>
          <li>
            <strong>Violence & Terrorism:</strong> Graphic violence, extremist content.
          </li>
          <li>
            <strong>Drugs & Illegal Substances:</strong> Promotion or sale of illegal substances.
          </li>
          <li>
            <strong>Pornographic & Sexual Content:</strong> Nudity, explicit materials.
          </li>
          <li>
            <strong>Misinformation & Scams:</strong> Fake news, phishing attempts.
          </li>
        </ol>

        <h2>4. PRIVACY AND DATA PROTECTION</h2>
        <p>Do not share private or sensitive information, including:</p>
        <ul>
          <li>Personal addresses, phone numbers, or financial data</li>
          <li>Private conversations or messages without consent</li>
          <li>Any third-party personal information without explicit authorization.</li>
        </ul>

        <h2>5. INTELLECTUAL PROPERTY & COPYRIGHT</h2>
        <p>Users must:</p>
        <ul>
          <li>Share only content they own or have permission to use</li>
          <li>Credit original creators when applicable</li>
        </ul>
        <p>Users must not:</p>
        <ul>
          <li>Post copyrighted material without authorization</li>
          <li>Impersonate individuals, brands, or organizations</li>
        </ul>

        <h2>6. ADVERTISING AND SPAM</h2>
        <p>Users must not:</p>
        <ul>
          <li>Post excessive or misleading advertisements</li>
          <li>Engage in spamming, mass messaging, or bot activity</li>
          <li>Use deceptive practices to artificially increase engagement, such as fake likes, comments, or follows.</li>
        </ul>

        <h2>7. REPORTING VIOLATIONS</h2>
        <p>Users can report violations through the App's report system. Reports will be reviewed, and appropriate actions will be taken. False or malicious reports may result in penalties, including account suspension. Repeated violations by a reported user may lead to stricter enforcement actions, including permanent banning.</p>

        <h2>8. CONSEQUENCES OF VIOLATIONS</h2>
        <ol>
          <li><strong>Warning:</strong> For minor infractions</li>
          <li><strong>Content Removal:</strong> If content violates guidelines</li>
          <li><strong>Temporary Suspension:</strong> For repeated violations</li>
          <li><strong>Permanent Ban:</strong> For severe or repeated offenses</li>
        </ol>

        <h2>9. APPEALS PROCESS</h2>
        <p>Users who believe their content or account was removed unfairly may submit an appeal via <a href="mailto:support@socius.icu">support@socius.icu</a>. All appeals will be reviewed, but submission does not guarantee reinstatement.</p>
      
        <br />
        {/* 5. Disclaimers */}
        <h1>Disclaimers & Liability Waivers</h1>
        <p><strong>Effective Date:</strong> 24/03/2025</p>

        <p>This Disclaimers & Liability Waivers document ("Disclaimer") governs the use of <strong>trippin</strong> (the "App") operated by <strong>Socius Apps Ltd</strong>, a company incorporated in Cyprus, and available worldwide.</p>
        <p>By accessing or using the App, you acknowledge that you have read, understood, and agree to be bound by this Disclaimer. If you do not agree, you must discontinue the use of the App immediately.</p>

        <h2>1. GENERAL DISCLAIMER</h2>
        <p><strong>1.1</strong> The App is provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied.</p>
        <p><strong>1.2</strong> We do not warrant that the App will be uninterrupted, error-free, secure, or free from viruses or harmful components.</p>
        <p><strong>1.3</strong> We are not responsible for any loss, damage, or harm resulting from the use of the App, including reliance on any information posted by users.</p>

        <h2>2. COMPLIANCE WITH GLOBAL DATA PROTECTION LAWS</h2>
        <p>We comply with all applicable global data protection laws, including but not limited to:</p>
        <ul>
          <li><strong>General Data Protection Regulation (GDPR)</strong> -- European Union</li>
          <li><strong>California Consumer Privacy Act (CCPA)</strong> -- United States (California residents)</li>
          <li><strong>Children's Online Privacy Protection Act (COPPA)</strong> -- United States</li>
          <li><strong>Other relevant data protection and privacy laws</strong> in regions where the App is accessible</li>
        </ul>
        <p>For detailed information on how we process personal data, please refer to our Privacy Policy.</p>

        <h2>3. COLLECTION & PROCESSING OF USER DATA</h2>
        <p><strong>3.1 Types of Data Collected:</strong></p>
        <p>By using the App, you consent to the collection and processing of the following data:</p>
        <ul>
          <li><strong>Location Data</strong> -- To enable geo-tagging and enhance user experience.</li>
          <li><strong>Camera & Gallery Access</strong> -- To allow users to upload photos and videos.</li>
          <li><strong>Microphone Access</strong> -- To support voice or audio features.</li>
          <li><strong>User Behavior Data</strong> -- To analyze user interactions for personalized experiences and improvements.</li>
        </ul>

        <p><strong>3.2 User Control & Data Deletion:</strong></p>
        <ul>
          <li>Users may delete their accounts and all associated data at any time via the App's settings.</li>
          <li>Upon deletion, all personal data related to the user will be removed from our systems, except where retention is legally required.</li>
        </ul>

        <p><strong>3.3 Third-Party Data Processing & Hosting:</strong></p>
        <ul>
          <li>Our App uses Google Cloud Services for data storage and hosting.</li>
          <li>We utilize Facebook Ads and Google Ads for advertising and may share non-identifiable user data with these third parties.</li>
        </ul>
        <p>For more details, please review our Privacy Policy.</p>

        <h2>4. USER CONTENT & RESPONSIBILITIES</h2>
        <p><strong>4.1</strong> Users are solely responsible for the content they post. The following are strictly prohibited:</p>
        <ul>
          <li>Hate speech, harassment, or threats</li>
          <li>Violence, drug-related content, or illegal activities</li>
          <li>Nudity, pornography, or sexually explicit material</li>
          <li>Content violating copyright or intellectual property rights</li>
        </ul>

        <p><strong>4.2 Moderation & Enforcement:</strong></p>
        <ul>
          <li>We reserve the right to remove, restrict, or suspend any content or accounts violating these guidelines.</li>
          <li>We may, at our discretion, permanently ban users who repeatedly violate our policies.</li>
        </ul>

        <h2>5. AGE RESTRICTIONS</h2>
        <p><strong>5.1 Minimum Age Requirement:</strong></p>
        <ul>
          <li>The App is intended for users aged 13 and above.</li>
          <li>If you are under 13, you are not permitted to use the App under COPPA regulations.</li>
        </ul>

        <p><strong>5.2 Parental Responsibility:</strong></p>
        <p>Parents or guardians of users under 18 are responsible for monitoring and supervising their online activity.</p>

        <h2>6. THIRD-PARTY ADVERTISING & SERVICES</h2>
        <p><strong>6.1 Third-Party Advertisements:</strong></p>
        <ul>
          <li>The App displays advertisements from Google Ads and Facebook Ads.</li>
          <li>We do not endorse or take responsibility for the accuracy, legality, or content of third-party ads.</li>
        </ul>

        <p><strong>6.2 Third-Party Data Collection:</strong></p>
        <ul>
          <li>Advertisers may collect non-identifiable user data for targeted advertising.</li>
          <li>Users can manage their ad preferences through their device settings.</li>
        </ul>

        <h2>7. REPORTING SYSTEM & USER ACCOUNT SUSPENSIONS</h2>
        <p><strong>7.1 In-App Reporting System:</strong></p>
        <ul>
          <li>Users can report inappropriate content or behavior using the App's reporting feature.</li>
          <li>Reports will be reviewed, and necessary action will be taken at our discretion.</li>
        </ul>

        <p><strong>7.2 Account Suspension & Termination:</strong></p>
        <ul>
          <li>We reserve the right to suspend or permanently terminate any account that violates our content guidelines or terms of service.</li>
          <li>No refunds or compensation will be provided for suspended or terminated accounts.</li>
        </ul>

        <h2>8. LIMITATION OF LIABILITY</h2>
        <p><strong>8.1 No Liability for Damages:</strong></p>
        <p>To the fullest extent permitted by law, we are not liable for:</p>
        <ul>
          <li>Direct, indirect, incidental, special, consequential, or punitive damages arising from App usage.</li>
          <li>Loss of data, business, revenue, or personal injury related to the App's use.</li>
        </ul>

        <p><strong>8.2 Indemnification:</strong></p>
        <p>Users agree to indemnify, defend, and hold harmless Socius Apps Ltd, its affiliates, officers, and employees from any claims or damages arising from:</p>
        <ul>
          <li>Violation of this Disclaimer</li>
          <li>Misuse of the App</li>
          <li>Infringement of third-party rights</li>
        </ul>

        <h2>9. SECURITY & DATA PROTECTION MEASURES</h2>
        <p><strong>9.1</strong> We implement reasonable security measures to protect user data. However, we do not guarantee absolute security.</p>
        <p><strong>9.2</strong> Users acknowledge that data transmission over the internet may be subject to unauthorized access or breaches.</p>

        <h2>10. CHANGES TO THIS DISCLAIMER</h2>
        <p><strong>10.1</strong> We reserve the right to update or modify this Disclaimer at any time.</p>
        <p><strong>10.2</strong> Continued use of the App constitutes acceptance of the latest version of this Disclaimer.</p>

        <h2>11. GOVERNING LAW & JURISDICTION</h2>
        <p><strong>11.1</strong> This Disclaimer is governed by the laws of Cyprus.</p>
        <p><strong>11.2</strong> Any disputes arising from the use of the App shall be resolved in the courts of Cyprus, unless otherwise required by applicable consumer protection laws.</p>

        <h2>12. CONTACT INFORMATION</h2>
        <p>If you have any questions or concerns about this Disclaimer, please contact us at:</p>
        <ul>
          <li><strong>Company Name:</strong> Socius Apps Ltd</li>
          <li><strong>Email:</strong> <a href="mailto:support@socius.icu">support@socius.icu</a></li>
          <li><strong>Address:</strong> Megalou Alexandrou, 38, 2682, Paliometoxo, Nicosia, Cyprus.</li>
        </ul>

        <br />
        {/* 6. Cookie Policy */}
        <h1>Cookie Policy</h1>
        <p><strong>Effective Date:</strong> 24/03/2025</p>

        <p>Socius Apps Ltd ("we," "us," or "our") is committed to protecting your privacy and ensuring transparency in how we use cookies and similar technologies in our mobile application. This Cookie Policy explains what cookies are, how we use them, and your choices regarding their use.</p>

        <h2>1. SCOPE OF THIS POLICY</h2>
        <p>This Cookie Policy applies to all users of our mobile application worldwide. It is designed to comply with applicable data protection laws, including but not limited to:</p>
        <ul>
          <li><strong>General Data Protection Regulation (GDPR)</strong> -- European Union</li>
          <li><strong>California Consumer Privacy Act (CCPA)</strong> -- United States (California)</li>
          <li><strong>Children's Online Privacy Protection Act (COPPA)</strong> -- United States</li>
          <li><strong>Other relevant data protection and privacy laws</strong></li>
        </ul>
        <p>By using our application, you consent to the use of cookies and similar technologies as described in this policy.</p>

        <h2>2. WHAT ARE COOKIES AND SIMILAR TECHNOLOGIES?</h2>
        <p>Cookies are small text files stored on your device when you interact with our mobile application. These cookies help us improve your user experience, provide security, and analyze app usage.</p>
        <p>In addition to cookies, we use pixels, local storage, and similar tracking technologies for various functionalities, such as analytics and advertising.</p>

        <h2>3. HOW WE USE COOKIES</h2>
        <p>We use cookies and similar technologies to:</p>
        <ol>
          <li><strong>Authenticate Users</strong> -- Verify login credentials and maintain session security.</li>
          <li><strong>Improve Performance</strong> -- Analyze app usage and optimize functionality.</li>
          <li><strong>Enhance User Experience</strong> -- Remember user preferences, such as language and display settings.</li>
          <li><strong>Enable Advertising and Marketing</strong> -- Deliver targeted ads via Facebook Ads and Google Ads.</li>
          <li><strong>Facilitate Essential Features</strong> -- Support functionalities such as location-based content, camera/gallery uploads, and microphone access.</li>
        </ol>

        <h2>4. TYPES OF COOKIES WE USE</h2>
        <p>We use different types of cookies to enhance user experience and improve our services. These include:</p>
        <ol>
          <li>
            <strong>Essential Cookies</strong> -- These cookies are necessary for the core functionalities of the app, such as login authentication and security. Without them, certain features may not function properly.
          </li>
          <li>
            <strong>Performance Cookies</strong> -- These cookies help us analyze how users interact with the app, allowing us to optimize performance and enhance usability.
          </li>
          <li>
            <strong>Advertising Cookies</strong> -- These cookies enable us to deliver personalized advertisements through Google Ads and Facebook Ads, ensuring that users receive relevant content.
          </li>
          <li>
            <strong>Functionality Cookies</strong> -- These cookies store user preferences, such as language settings, theme choices, and notification preferences, to improve the overall user experience.
          </li>
        </ol>
        <p>Some cookies are first-party cookies, which are set by us, while others are third-party cookies, which are placed by external services we integrate with.</p>

        <h2>5. THIRD-PARTY SERVICES AND DATA SHARING</h2>
        <p>Our app integrates third-party services that may place cookies on your device. These services include but are not limited to:</p>
        <ol>
          <li><strong>Google Cloud Services</strong> -- Used for data storage and processing.</li>
          <li><strong>Google Ads and Facebook Ads</strong> -- Used for targeted advertising and marketing.</li>
        </ol>
        <p>These third parties may collect and process data according to their own privacy and cookie policies. We encourage users to review their policies for more information.</p>

        <h2>6. USER DATA & PRIVACY COMPLIANCE</h2>
        <p>We are committed to global data privacy standards and comply with GDPR, CCPA, COPPA, and other applicable regulations. Key compliance measures include:</p>
        <ol>
          <li><strong>User Age Requirement</strong> -- The app is only available to individuals 13 years and older.</li>
          <li><strong>Accounts Deletion Option</strong> -- Users can request the deletion of their account and all associated data.</li>
          <li><strong>Reporting & Content Moderation</strong> -- We have a reporting system to flag inappropriate content.</li>
          <li>
            <strong>Content Restrictions</strong> -- Users are prohibited from posting content related to:
            <ul>
              <li>Hate speech</li>
              <li>Violence</li>
              <li>Drugs</li>
              <li>Nudity or pornographic material</li>
              <li>Any other content that violates community standards</li>
            </ul>
          </li>
        </ol>
        <p>We reserve the right to delete or suspend accounts that violate these policies.</p>

        <h2>7. MANAGING COOKIE PREFERENCES</h2>
        <p>Users have control over cookie settings and can:</p>
        <ul>
          <li>Adjust device settings to block or delete cookies.</li>
          <li>Opt out of personalized ads via Google Ads and Facebook Ads settings.</li>
          <li>Modify in-app privacy settings to customize data preferences.</li>
        </ul>
        <p>Disabling certain cookies may impact app functionality.</p>

        <h2>8. UPDATES TO THIS COOKIE POLICY</h2>
        <p>We may update this policy from time to time to reflect changes in regulations, technology, or business practices. Any changes will be communicated through the app or our website.</p>
        <p>We encourage users to review this policy periodically for the latest updates.</p>

        <h2>9. CONTACT INFORMATION</h2>
        <p>For any inquiries regarding this Cookie Policy, please contact us at:</p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:support@socius.icu">support@socius.icu</a></li>
          <li><strong>Company Address:</strong> Megalou Alexandrou, 38, 2682, Paliometoxo, Nicosia, Cyprus</li>
        </ul>
        <p>By continuing to use our application, you acknowledge that you have read, understood, and agreed to this Cookie Policy.</p>
      </div>
    </>
  );
};

export default TermsAndConditions;